<template>
  <div class="addImg">
    <input id="upload_file" type="file" accept="image" ref="uploadFile" @change="upload($event)" style="display: none"/>
    <ul v-if="imgList.length">
      <li  class="imgItem" v-for="(item,i) in imgList" :key="i" @click="fileDel(i)">
        <img :src="item.file.src" alt=""/>
      </li>
    </ul>
    <div class="addIcon" @click="fileClick">
      <i class="iconfont ">add</i>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  data(){
    return{
      imgList:[],
      size:0
    }
  },
  methods:{
    fileClick(){//点击上传
      if(this.imgList.length<3)
        this.$refs.uploadFile.click()
      else
        Toast('Upload Complete')
    },
    upload(el){
      if (!el.target.files[0].size) return;
			this.fileList(el.target.files);
			el.target.value = ''
    },
    fileList(files){
			for (let i = 0; i < files.length; i++) {
				this.fileAdd(files[i]);
			}
    },
    fileAdd(file){
			this.size = this.size + file.size;//总大小
      let reader = new FileReader();
			reader.vue = this;
      reader.readAsDataURL(file);
			reader.onload = () =>{
				file.src = reader.result;
				this.imgList.push({
				file
				});
      }
    },
    fileDel(index){//删除
			this.size = this.size - this.imgList[index].file.size;//总大小
			this.imgList.splice(index, 1);
		},
     
  }
}
</script>

<style>
.addImg{
  width: 100%;
}
.addImg::after{
  content: "";
  display: block;
  clear: both;
}
.addImg ul{
  /* display: inline-block; */
  height: 50px;
  float: left;
}
.addImg li{
  display: inline-block;
  width: 25%;
}
.addImg>div{
  float: left;
  /* display: inline-block; */
}
</style>